import { getDefaultPopperRoot } from '@sas/nova-commons/hooks/usePopperRoot';
import { getRootClassName, setRootClassName } from '../config';
import { getLocaleTextDir } from '@sas-dvr/internal-va-react-core/config';

function setPopperRootStyles(rootClassName: string) {
  const $popperRoot = getDefaultPopperRoot();
  $popperRoot.classList.add(rootClassName);
  $popperRoot.setAttribute('dir', getLocaleTextDir());
}

export function initRootStyles(rootClassName: string) {
  if (getRootClassName()) {
    return;
  }
  setRootClassName(rootClassName);
  if (document.body) {
    setPopperRootStyles(rootClassName);
  } else {
    window.addEventListener('DOMContentLoaded', () => setPopperRootStyles(rootClassName));
  }
}
